import { INameValueObj } from '../../../types/nameValue';
import { EDealTypeEx } from '../../../constants/dealTypeEx';

export const DEMAND_DEAL_TYPES: INameValueObj[] = [
  { value: EDealTypeEx.Sale, name: 'Продать' },
  { value: EDealTypeEx.Buy, name: 'Купить' },
  { value: EDealTypeEx.SellToBuy, name: 'Продать, чтобы купить' },
  { value: EDealTypeEx.Rent, name: 'Сдать' },
  { value: EDealTypeEx.Tenant, name: 'Снять' },
];
